<template>
  <the-auth-navbar id="header"></the-auth-navbar>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import TheAuthNavbar from '@/components/layout/TheAuthNavbar.vue';

export default defineComponent({
  name: 'MainPage',
  components: {
    TheAuthNavbar,
  },
});
</script>

<style scoped>
#header {
  /* Auth navbar handles its own padding */
}
</style>
